/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_NameInputs */

const en_mk_sol_startup_name = /** @type {(inputs: Mk_Sol_Startup_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`early-stage startups`)
};

const id_mk_sol_startup_name = /** @type {(inputs: Mk_Sol_Startup_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`startup tahap awal`)
};

/**
* | output |
* | --- |
* | "early-stage startups" |
*
* @param {Mk_Sol_Startup_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_name = /** @type {((inputs?: Mk_Sol_Startup_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_name(inputs)
	return en_mk_sol_startup_name(inputs)
});